import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dd5adfde&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=dd5adfde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5adfde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd5adfde')) {
      api.createRecord('dd5adfde', component.options)
    } else {
      api.reload('dd5adfde', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dd5adfde&scoped=true&", function () {
      api.rerender('dd5adfde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customParameter/index.vue"
export default component.exports